// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';



const { Exam, Student, Room, Layout, Seat, AdminComponent, UserComponent, AdminBoard, UserBoard, AdminSubject, UserSubject, Subject, Qualification, ExamCycle, ExamInstanceStudent, ExamInstanceRoom, ExamInstance, Organization, Invigilator, RoomInvigilator, Display } = initSchema(schema);

export {
  Exam,
  Student,
  Room,
  Layout,
  Seat,
  AdminComponent,
  UserComponent,
  AdminBoard,
  UserBoard,
  AdminSubject,
  UserSubject,
  Subject,
  Qualification,
  ExamCycle,
  ExamInstanceStudent,
  ExamInstanceRoom,
  ExamInstance,
  Organization,
  Invigilator,
  RoomInvigilator,
  Display
};